import { OnlineActions } from "./Action";

let initialState = {
  isUserOnine: null,
  isUserOnineError: null,
};

export const onlineStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case OnlineActions.CHANGE_STATUS:
      return {
        ...state,
        isUserOnine: action.payload,
        isUserOnineError: null,
      };

    case OnlineActions.CHANGE_STATUS_FAILURE:
      return {
        ...state,
        isUserOnine: null,
        isUserOnineError: action.payload,
      };
    default:
      return state;
  }
};
